import React from 'react'
import { Tooltip, Button } from '@mui/material';

const MyTooltip = ({ title, placement, color, onClick, disabled, icon }) => {
    return (<Tooltip title={title} placement={placement}>
        <span>
            <Button variant="contained" color={color} size="small" disabled={disabled || false} sx={{ marginRight: 1, color: "#fff" }} onClick={onClick}>{icon}</Button>
        </span>
    </Tooltip>)
}

export default MyTooltip